import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Variante = "primario" | "secundario" | "fantasma" | "perigo";
type Tamanho = "sm" | "md" | "icone";

const variantes: Record<Variante, string> = {
  primario: "bg-gold-500 text-neutral-900 hover:bg-gold-600 active:bg-gold-600 shadow-xs", // texto escuro: AA sobre o dourado oficial
  secundario: "border border-neutral-300 bg-white text-neutral-800 hover:bg-neutral-100",
  fantasma: "text-neutral-700 hover:bg-neutral-100",
  perigo: "bg-danger-500 text-white hover:opacity-90",
};
const tamanhos: Record<Tamanho, string> = {
  sm: "h-8 px-3 text-[13px] gap-1.5",
  md: "h-10 px-4 text-sm gap-2",
  icone: "size-10 justify-center",
};

export function Botao({
  variante = "primario",
  tamanho = "md",
  className,
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variante?: Variante; tamanho?: Tamanho }) {
  return (
    <button
      type={type}
      className={cn(
        "pressionar inline-flex shrink-0 items-center rounded-md font-semibold transition-colors duration-200 disabled:pointer-events-none disabled:opacity-50",
        variantes[variante],
        tamanhos[tamanho],
        className,
      )}
      {...props}
    />
  );
}
